import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Status } from '@mm/components';
import { CaretRightFilled } from '@ant-design/icons';
import classNames from 'classnames';
import css from './GoLiveStep.module.css';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { useXRayConfigurationCRUDActions } from '@mm/state/actions/XRayConfiguration';
import {
  hasConfiguredFb,
  selectXRayConfig,
} from '@mm/state/selectors/xrayConfigSelectors';
import { emptyEventsConfig } from '../SetupForm';
import {
  errorToast,
  successToast,
} from '../../../../../../../common/helpers/toast';

export const GoLiveStep = ({ isDisabled }: { isDisabled: boolean }) => {
  const [busy, setBusy] = useState(false);

  const defaultConfiguration = useSelector(selectXRayConfig);

  const chatbotId = useSelector(activeChatbotIdSelector);

  const xRayConfigurationCRUDActions = useXRayConfigurationCRUDActions();

  const handleStart = async () => {
    setBusy(true);

    try {
      await xRayConfigurationCRUDActions.updateXRayEventsConfiguration(
        chatbotId,
        {
          ...defaultConfiguration,
          configurations:
            defaultConfiguration?.configurations || emptyEventsConfig,
          active: !defaultConfiguration?.active,
        },
      );
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className={classNames(css.card, css.live)}>
      <Status
        status={
          defaultConfiguration?.active
            ? 'Events are enabled'
            : 'Events are disabled'
        }
        color={defaultConfiguration?.active ? 'var(--color-green-6)' : 'gray'}
        noCapitalize
      />

      <div className={css.buttons}>
        {defaultConfiguration?.active ? (
          <Button
            color="red"
            css={{ container: classNames(css.submitBtn, css.redBtn) }}
            onClick={handleStart}
            disabled={busy}
          >
            <CaretRightFilled className={css.carretIcon} />
            Stop
          </Button>
        ) : (
          <Button
            color="green"
            css={{ container: classNames(css.submitBtn, css.greenBtn) }}
            onClick={handleStart}
            disabled={busy || isDisabled}
          >
            <CaretRightFilled className={css.carretIcon} />
            Go live
          </Button>
        )}

        <Button
          css={{ container: css.testBtn }}
          disabled={!hasConfiguredFb(defaultConfiguration)}
          onClick={async () => {
            if (!hasConfiguredFb(defaultConfiguration)) {
              return;
            }
            try {
              const res =
                await xRayConfigurationCRUDActions.testXRayEventsConfiguration(
                  chatbotId,
                );

              if (res.response.eventsReceived) {
                successToast(`Event received`);
                return;
              }

              if (res?.response?.error?.message) {
                errorToast(
                  `${res.response.error.message} (code ${res.response.error.code})`,
                );
                console.debug(res.response.error);
              }
              // eslint-disable-next-line no-empty
            } finally {
            }
          }}
        >
          Send Test Event
        </Button>
      </div>
    </div>
  );
};
